import { render, staticRenderFns } from "./FormPalveluhakemusAloita.vue?vue&type=template&id=6c641b6a&scoped=true&"
import script from "./FormPalveluhakemusAloita.vue?vue&type=script&lang=js&"
export * from "./FormPalveluhakemusAloita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c641b6a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c641b6a')) {
      api.createRecord('6c641b6a', component.options)
    } else {
      api.reload('6c641b6a', component.options)
    }
    module.hot.accept("./FormPalveluhakemusAloita.vue?vue&type=template&id=6c641b6a&scoped=true&", function () {
      api.rerender('6c641b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormPalveluhakemusAloita.vue"
export default component.exports